/**
 * AWS Cognito 設定
 */

// スタッフ用 Cognito設定
export const cognitoStaffConfig = {
  // User Pool ID
  userPoolId:
    process.env.VUE_APP_COGNITO_STAFF_USER_POOL_ID ||
    "ap-northeast-1_YpEb3SSzV",

  // App Client ID
  clientId:
    process.env.VUE_APP_COGNITO_STAFF_CLIENT_ID || "1l9os09vhbrjal8g6tl21r0v2r",

  // Cognito Domain
  domain:
    process.env.VUE_APP_COGNITO_STAFF_DOMAIN ||
    "https://gaia-shop-order-2025.auth.ap-northeast-1.amazoncognito.com",

  // リダイレクトURI（環境に応じて自動設定）
  redirectUri:
    process.env.VUE_APP_COGNITO_STAFF_REDIRECT_URI ||
    `${window.location.origin}/backyard/callback`,

  // サインアウトURI
  signOutUri:
    process.env.VUE_APP_COGNITO_STAFF_SIGNOUT_URI ||
    `${window.location.origin}/backyard`,

  // レスポンスタイプ
  responseType: "code",

  // スコープ（Cognito App Clientで許可されているスコープのみ指定）
  // profile スコープを追加することで、グループ情報がトークンに含まれる可能性がある
  scope: "openid email profile",
};

// お客様用 Cognito設定
export const cognitoCustomerConfig = {
  // User Pool ID
  userPoolId:
    process.env.VUE_APP_COGNITO_CUSTOMER_USER_POOL_ID ||
    "ap-northeast-1_88r4HS5RJ",

  // App Client ID
  clientId:
    process.env.VUE_APP_COGNITO_CUSTOMER_CLIENT_ID ||
    "5icjng6kih4ssd29l2tsj1sou",

  // Cognito Domain
  domain:
    process.env.VUE_APP_COGNITO_CUSTOMER_DOMAIN ||
    "https://gaia-shop-customers-2025.auth.ap-northeast-1.amazoncognito.com",

  // リダイレクトURI（環境に応じて自動設定）
  redirectUri:
    process.env.VUE_APP_COGNITO_CUSTOMER_REDIRECT_URI ||
    `${window.location.origin}/auth/callback`,

  // サインアウトURI
  signOutUri:
    process.env.VUE_APP_COGNITO_CUSTOMER_SIGNOUT_URI ||
    `${window.location.origin}`,

  // レスポンスタイプ
  responseType: "code",

  // スコープ
  scope: "openid email profile",
};

// 後方互換性のため、デフォルトはスタッフ用
export const cognitoConfig = cognitoStaffConfig;

/**
 * Cognito Hosted UI ログインURLを生成（スタッフ用）
 */
export function getStaffLoginUrl(): string {
  const params = new URLSearchParams({
    client_id: cognitoStaffConfig.clientId,
    response_type: cognitoStaffConfig.responseType,
    scope: cognitoStaffConfig.scope,
    redirect_uri: cognitoStaffConfig.redirectUri,
  });

  return `${cognitoStaffConfig.domain}/oauth2/authorize?${params.toString()}`;
}

/**
 * Cognito Hosted UI ログアウトURLを生成（スタッフ用）
 */
export function getStaffLogoutUrl(): string {
  const params = new URLSearchParams({
    client_id: cognitoStaffConfig.clientId,
    logout_uri: cognitoStaffConfig.signOutUri,
  });

  return `${cognitoStaffConfig.domain}/logout?${params.toString()}`;
}

/**
 * Cognito Hosted UI ログインURLを生成（お客様用）
 */
export function getCustomerLoginUrl(): string {
  const params = new URLSearchParams({
    client_id: cognitoCustomerConfig.clientId,
    response_type: cognitoCustomerConfig.responseType,
    scope: cognitoCustomerConfig.scope,
    redirect_uri: cognitoCustomerConfig.redirectUri,
    lang: "ja", // 日本語を設定
  });

  return `${
    cognitoCustomerConfig.domain
  }/oauth2/authorize?${params.toString()}`;
}

/**
 * Cognito Hosted UI ログアウトURLを生成（お客様用）
 */
export function getCustomerLogoutUrl(): string {
  const params = new URLSearchParams({
    client_id: cognitoCustomerConfig.clientId,
    logout_uri: cognitoCustomerConfig.signOutUri,
  });

  return `${cognitoCustomerConfig.domain}/logout?${params.toString()}`;
}

// 後方互換性のため
export const getLoginUrl = getStaffLoginUrl;
export const getLogoutUrl = getStaffLogoutUrl;
